// Core React Imports
import React, { useEffect, useRef } from "react";

// Local Imports
import { AlertDialogBackground, DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";

// CSS/Stylesheets
import "./WidgetAlertDialogFreezeSuccess.css";

const WidgetAlertDialogFreezeSuccess = ({ onCancel, messageText }) => {
  const onCancelRef = useRef(onCancel);
  onCancelRef.current = onCancel;

  useEffect(() => {
    const timer = setTimeout(() => {
      onCancelRef.current?.();
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AlertDialogBackground onClick={() => onCancelRef.current?.()}>
      <DivColumn className="alert-dialog-freeze-success" onClick={(event) => event.stopPropagation()}>
        <WidgetIconFive
          iconProp={ConstantsImages.FREEZE_SUCCESS_ILLUSTRATION_IMAGE}
          widthIconProp="7.1rem"
          heightIconProp="7.2rem"
        />
        <ParagraphText className="alert-dialog-freeze-success-text">{messageText}</ParagraphText>
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogFreezeSuccess;
